<template>
  <div class="left-bar" :class="{'big-bar': big_size, 'sm-bar': !big_size}">
    <div class="left-bar-top-1">
      <a class="one-bar" v-for="(menu, index) in menus_top" href="javascript:;" @click="clickMenuF(menu, index, 'top_top')">
        <div class="bar-icon" :class="{'sm-iconfont': big_size}" >
          <i class="iconfont" :class="menu.icon"></i>
        </div>
        <div class="bar-leabel" v-html="menu.leabel" :class="{'big-bar-leabel': big_size, 'sm-bar-leabel': !big_size}">
        </div>
      </a>
    </div>
    <div class="bar-fg">
    </div>
    <div class="left-bar-top">
      <a class="one-bar" v-for="(menu, index) in menus" :class="{'active-bar': active_type === 'top' && active_index === index, 'hide-bar': !menu.active}" href="javascript:;" @click="clickMenuF(menu, index, 'top')">
        <div class="bar-icon" :class="{'sm-iconfont': big_size}" >
          <i class="iconfont" :class="menu.icon"></i>
        </div>
        <div class="bar-leabel" v-html="menu.leabel" :class="{'big-bar-leabel': big_size, 'sm-bar-leabel': !big_size}">
        </div>
        <div class="right-menu">
          <a href="javascript:;" class="children-menu" :class="{'hide-bar': !data.active}" @click.stop="clickMenu(data.key, data.active, index, 'top')" v-for="data in menu.children" v-html="data.leabel"></a>
        </div>
      </a>
    </div>
    <div class="bar-fg">
    </div>
    <div class="left-bar-bottom">
      <a class="one-bar" v-for="(menu, index) in bottomMenus" href="javascript:;" :class="{'active-bar': active_type === 'btm' && active_index === index, 'hide-bar': !menu.active}" @click="clickMenuF(menu, index, 'btm')">
        <div class="bar-icon" :class="{'sm-iconfont': big_size}" >
          <i class="iconfont" :class="menu.icon"></i>
        </div>
        <div class="bar-leabel" v-html="menu.leabel" :class="{'big-bar-leabel': big_size, 'sm-bar-leabel': !big_size}">
        </div>
        <div class="right-menu">
          <a href="javascript:;" class="children-menu" :class="{'hide-bar': !data.active}" @click.stop="clickMenu(data.key, data.active, index, 'btm')" v-for="data in menu.children" v-html="data.leabel"></a>
        </div>
      </a>
      <!-- <a class="one-bar" href="javascript:;" @click="goOther">
        <div class="bar-icon"  :class="{'sm-iconfont': !big_size}">
          <i class="iconfont icon-shishijiankong"></i>
        </div>
        <div class="bar-leabel" :class="{'big-bar-leabel': big_size, 'sm-bar-leabel': !big_size}">
          实时监控
        </div>
      </a> -->
    </div>
    <div style="display: none">{{path}}{{preStatus}}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      big_size: true,
      active_type: '',
      active_index: -1,
      bottomMenus: [{
        leabel: '基础数据',
        icon: 'icon-jichuziyuan',
        key: 'single.gas',
        active: true,
        children: [{
          leabel: '加油站',
          key: 'single.gas',
          active: true
        },
        {
          leabel: '车辆',
          key: 'single.car',
          active: true
        },
        {
          leabel: '驾驶员',
          key: 'single.driver',
          active: true
        },
        {
          leabel: '油库',
          key: 'single.oil_depot',
          active: true
        }]
      },
      {
        leabel: '图表展示',
        icon: 'icon-tubiao',
        key: 'oil_chart',
        active: true
      }],
      menus_top: [{
        icon: 'icon-qiandao',
        leabel: '车辆签到',
        key: 'single.car',
        active: true
      }],
      menus: [{
        icon: 'icon-shujudaoru',
        leabel: '数据导入',
        key: 'single.source_data_pre',
        active: true
      },
      {
        icon: 'icon-duocengshujuxiaoyan',
        leabel: '数据校验',
        key: 'single.prediction_check',
        active: false
      },
      {
        icon: 'icon-xiansunfenxi',
        leabel: '分析预测',
        key: 'single.prediction',
        active: false
      },
      {
        icon: 'icon-huanyihuan',
        leabel: '订单调整',
        key: 'single.adjust_order',
        active: false
      },
      {
        icon: 'icon-youguanche',
        leabel: '每日订单',
        key: 'single.prediction_station',
        active: false,
        children: [{
          leabel: '加油站',
          key: 'single.prediction_station',
          active: false
        },
        {
          leabel: '车辆',
          key: 'single.prediction_car',
          active: false
        }]
      }]
    }
  },
  computed: {
    path: {
      get () {
        let path = this.$store.state.route.path
        let vm = this
        let routeName = this.$router.history.current.name
        this.menus.forEach(function (item, index) {
          if (item.key && item.key === routeName) {
            vm.active_index = index
          }
        })
        return path
      }
    },
    preStatus: {
      get () {
        let data = this.$store.getters.flowStatus
        if (data === 10) {
          this.menus[1].active = true
        } else if (data === 20) {
          this.menus[2].active = true
        } else if (data === 30) {
          this.menus[3].active = true
        } else if (data === 40) {
          this.menus[4].active = true
          this.menus[4].children[0].active = true
          this.menus[4].children[1].active = true
        }
        return data
      }
    }
  },
  methods: {
    clickMenuF (menu, index, type) {
      if (menu.active && menu.key) {
        this.$router.push({ name: menu.key })
        this.active_index = index
        this.active_type = type
      }
    },
    clickMenu (key, active, index, type) {
      if (active && key) {
        this.active_index = index
        this.$router.push({ name: key })
        this.active_type = type
      }
    },
    goOther () {
      window.open('http://mii-ro.com/VRPdemo7.html')
    }
  },
  created () {
    let vm = this
    this.menus.forEach(function (item, index) {
      if (vm.$route.name === item.key) {
        vm.active_index = index
      }
    })
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
@left-bar-width: 4.5em;
@left-bar-width-sm: 3em;
@transition-time: 0.5s;
.one-bar:hover {
  background-color: @bak-color-1;
  border-left: 0.31em solid @line-color;
  .right-menu {
    display: flex !important;
  }
}
.children-menu:hover {
  background-color: @bak-color-1;
}
.bar-fg {
  min-height: 0.2rem;
  border-bottom: 0.1rem solid #00ccff;
  border-top: 0.1rem solid #00ccff;
  margin: 0 0.27rem;
}
.children-menu {
  width: 100%;
  font-size: 0.8em;
  color: #fff;
  height: 4em;
  margin: 0.5em 0;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    margin-right: 0.5em;
  }
}

.right-menu {
  position: absolute;
  right: -7em;
  width: 7em;
  bottom: 0;
  flex-direction:column;
  display: none;
  background-color: @bak-color-2;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 0.5em; 
  border-bottom-right-radius: 0.5em; 
}
.sm-iconfont {
  .iconfont {
    font-size: 1.2em !important;
  }
  .icon-youguanche {
    font-size: 1.6em  !important;
  }
  .icon-jiayouzhan {
    font-size: 1.4em  !important;
  }
}
.sm-bar-leabel {
  transform:rotateY(90deg);
  color:  @bak-color-2;
}
.big-bar-leabel {
  transform:rotateY(0deg);
}
.sm-bar {
  width: @left-bar-width-sm;
}
.big-bar {
  width: @left-bar-width;
}
.left-bar {
  transition: @transition-time;
  z-index: 20000;
  display: flex;
  flex-direction: column;
  background-color: @bak-color-2;
}
.left-bar-top-1 {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.left-bar-top {
  display: flex;
  flex-direction: column;
  flex: 5;
}

.left-bar-bottom {
  display: flex;
  flex-direction: column;
  flex: 2;
}

.one-bar {
  position: relative;
  transition: 0.3s;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color:@font-color-1;
  letter-spacing: 0.19em;
  .bar-icon  .icon-cheliangtiaodu {
    line-height: 1.2;
    font-size: 2.5em;
  }
  .iconfont {
    transition: 0.3s;
    line-height: 1.6;
    color: @font-color-icon;
    font-size: 1.2em;
  }
  .bar-leabel {
    text-align: center;
    margin-top: 0.5em;
    letter-spacing: 1px;
    transition: @transition-time;
    font-size: 0.8em;
  }
}
.one-bar-s {
  transition: 0.3s;
  display: flex;
  height: 7em;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color:@font-color-1;
  letter-spacing: 0.19em;
  .iconfont {
    transition: 0.3s;
    line-height: 1.6;
    color: @font-color-icon;
    font-size: 1.2em;
  }
  .bar-leabel {
    transition: @transition-time;
    font-size: 0.8em;
    white-space:nowrap;
  }
}
.hide-bar {
  color: #999;
  .iconfont {
    color: #999;
  }
}
.active-bar {
  background-color: @bak-color-1;
  border-left: 0.31em solid @line-color;
}

.sm-bar-shou-btn {
  left: @left-bar-width-sm;
}

.big-bar-shou-btn {
  left: @left-bar-width;
}
.shou-btn-2 {
  z-index: 1000;
  color: #fff;
  transition: @transition-time;
  text-align: center;
  position: absolute;
  line-height: 1;
  width: 1.2em;
  top: 8em;
  background-color: @bak-color-2;
  padding: 0.3em 0;
  border-bottom-right-radius: 0.2em;
  border-top-right-radius: 0.2em;
  span {
    font-size: 0.8em;
  }
  i {
    font-size: 0.9em;
  }
}

.shou-btn {
  z-index: 1000;
  color: #fff;
  transition: @transition-time;
  text-align: center;
  position: absolute;
  line-height: 1;
  width: 1.2em;
  bottom: 2em;
  background-color: @bak-color-2;
  padding: 0.3em 0;
  border-bottom-right-radius: 0.2em;
  border-top-right-radius: 0.2em;
  span {
    font-size: 0.8em;
  }
  i {
    font-size: 0.9em;
  }
}
</style>



// WEBPACK FOOTER //
// LeftBarSingle.vue?45594f22